import {
  createContext,
  useState,
  ReactNode,
  useCallback,
  useEffect,
} from "react";
import { useCurrentRoute } from "../builder/mapping/page";

export interface PageStatusContextType<> {
  firstVisit: boolean;
  setVisited: () => void;
  getPageDataState: <T>() => {
    get: () => T;
    set: (data: T) => void;
  };
}

export const PageStatusContext = createContext<
  PageStatusContextType | undefined
>(undefined);

export const PageStatusProvider = ({ children }: { children: ReactNode }) => {
  const { currentPage } = useCurrentRoute() || {};
  const [firstVisit, setFirstVisit] = useState(true);
  const [pageData, setPageData] = useState<unknown>(null);

  useEffect(() => {
    setPageData(null);
  }, [currentPage]);

  const setVisited = useCallback(() => setFirstVisit(false), []);

  const getPageDataState = useCallback(
    <T,>() => ({
      get: () => pageData as T,
      set: (data: T) => setPageData(data),
    }),
    [pageData, setPageData],
  );

  return (
    <PageStatusContext.Provider
      value={{ firstVisit, setVisited, getPageDataState }}
    >
      {children}
    </PageStatusContext.Provider>
  );
};
